import React from 'react';
export var BlockTitle = function BlockTitle(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return React.createElement("div", {
    className: "block-title",
    title: title
  }, children);
};
export default BlockTitle;